import { useEffect } from 'react'

declare global {
  interface Window {
    __GEO__: string
    __LANG__: string
  }
}

export const useGlobalGeoLang = (geo: string, language: string) => {
  useEffect(() => {
    window.__GEO__ = geo
    window.__LANG__ = language
  }, [geo, language])
}